import React, { useState, useEffect, useRef } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Users, GraduationCap, BookOpenCheck, CalendarCheck,
  ClipboardList, Award, DollarSign, MessageSquare, Brain, BarChart2,
  Settings, LogOut, Bell, Building2, CreditCard, Menu, X, Mail,
  BookOpen, FileText, ChevronDown, Search, Grid, Megaphone, FileBarChart, UserCheck, CalendarDays,
  TrendingUp, Shield, Star, AlertTriangle, ShieldAlert, ClipboardCheck, Download, Users2, Network, Key,
  MessageSquareText
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../api';

const NAV_CONFIG = {
  master: [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/master/dashboard' },
    { icon: Building2, label: 'Schools', path: '/master/schools' },
    { icon: TrendingUp, label: 'Revenue & Billing', path: '/master/revenue' },
    { icon: Star, label: 'Plans & Pricing', path: '/master/plans' },
    { icon: Network, label: 'Partners', path: '/master/partners' },
    { icon: Grid, label: 'Games Management', path: '/master/games' },
    { icon: Award, label: 'Competitions', path: '/master/competitions' },
    { icon: BookOpenCheck, label: 'Quiz Management', path: '/master/quiz' },
    { icon: Shield, label: 'Roles & Access', path: '/master/roles' },
    { icon: Settings, label: 'System Settings', path: '/master/system' },
    { icon: CreditCard, label: 'Payment Settings', path: '/master/payment-settings' },
    { icon: Brain, label: 'AI Assistant', path: '/master/ai' },
    { icon: Mail, label: 'Marketing', path: '/master/marketing' },
    { icon: MessageSquare, label: 'WhatsApp', path: '/master/whatsapp' },
    { icon: MessageSquareText, label: 'SMS Platform', path: '/master/sms' },
    { icon: Key, label: 'Integrations', path: '/master/integrations' },
  ],  school: [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/school/dashboard', module: null },
    { icon: Users, label: 'Students', path: '/school/students', module: 'students' },
    { icon: GraduationCap, label: 'Teachers', path: '/school/teachers', module: 'teachers' },
    { icon: UserCheck, label: 'Parents', path: '/school/parents', module: 'parents' },
    { icon: BookOpenCheck, label: 'Classes & Subjects', path: '/school/classes', module: 'classes' },
    { icon: GraduationCap, label: 'Academics', path: '/school/academics', module: 'academics' },
    { icon: FileText, label: 'Teacher Assignments', path: '/school/teacher-assignments', module: 'teachers' },
    { icon: CalendarCheck, label: 'Attendance', path: '/school/attendance', module: 'attendance' },
    { icon: ClipboardList, label: 'Assignments', path: '/school/assignments', module: 'assignments' },
    { icon: Award, label: 'Exams & Results', path: '/school/exams', module: 'exams' },
    { icon: FileBarChart, label: 'Bulk Report Cards', path: '/school/bulk-report', module: 'exams' },
    { icon: Grid, label: 'Timetable', path: '/school/timetable', module: 'timetable' },
    { icon: Megaphone, label: 'Announcements', path: '/school/announcements', module: 'announcements' },
    { icon: DollarSign, label: 'Fees & Payments', path: '/school/fees', module: 'fees' },
    { icon: FileText, label: 'Admissions', path: '/school/admissions', module: null },
    { icon: MessageSquareText, label: 'SMS Platform', path: '/school/sms', module: null },
    { icon: CalendarDays, label: 'Events & Calendar', path: '/school/events', module: null },
    { icon: BookOpen, label: 'Lesson Notes', path: '/school/lesson-notes', module: null },
    { icon: BarChart2, label: 'Analytics', path: '/school/analytics', module: null },
    { icon: AlertTriangle, label: 'Early Warnings', path: '/school/early-warnings', module: null },
    { icon: TrendingUp, label: 'Business View', path: '/school/business-view', module: null },
    { icon: GraduationCap, label: 'Promotions', path: '/school/promotions', module: null },
    { icon: Users2, label: 'Groups & Houses', path: '/school/groups', module: null },
    { icon: ShieldAlert, label: 'Behavior Incidents', path: '/school/behavior-incidents', module: null },
    { icon: Shield, label: 'Roles & Permissions', path: '/school/roles', module: null },
    { icon: ClipboardCheck, label: 'Audit Logs', path: '/school/audit-logs', module: null },
    { icon: Brain, label: 'AI Assistant', path: '/school/ai', module: 'ai_assistant' },
    { icon: BarChart2, label: 'Reports', path: '/school/reports', module: 'reports' },
    { icon: Grid, label: 'Quiz Management', path: '/school/quiz-management', module: 'quiz_exam' },
    { icon: Brain, label: 'Student AI Activity', path: '/school/student-ai-activity', module: null },
    { icon: CreditCard, label: 'Subscription', path: '/school/subscription', module: null },
    { icon: Settings, label: 'Settings', path: '/school/settings', module: null },
  ],
  teacher: [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/teacher/dashboard' },
    { icon: ClipboardList, label: 'Assignments', path: '/teacher/assignments' },
    { icon: Award, label: 'Enter Results', path: '/teacher/results' },
    { icon: Users, label: 'My Class', path: '/teacher/my-class' },
    { icon: GraduationCap, label: 'My Students', path: '/teacher/my-students' },
    { icon: BookOpen, label: 'Lesson Notes', path: '/teacher/lessons' },
    { icon: Grid, label: 'Timetable', path: '/teacher/timetable' },
    { icon: Megaphone, label: 'Announcements', path: '/teacher/announcements' },
    { icon: AlertTriangle, label: 'Weak Topic Alerts', path: '/teacher/weak-topic-alerts' },
    { icon: CalendarDays, label: 'Events & Calendar', path: '/teacher/events' },
    { icon: Brain, label: 'AI Assistant', path: '/teacher/ai' },
  ],
  parent: [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/parent/dashboard' },
    { icon: Award, label: "Child's Results", path: '/parent/results' },
    { icon: DollarSign, label: 'School Fees', path: '/parent/fees' },
    { icon: BookOpen, label: 'Lesson Notes', path: '/parent/lessons' },
    { icon: Bell, label: 'Announcements', path: '/parent/announcements' },
    { icon: CalendarDays, label: 'Events & Calendar', path: '/parent/events' },
    { icon: Brain, label: 'AI Assistant', path: '/parent/ai' },
  ],
  student: [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/student/dashboard' },
    { icon: ClipboardList, label: 'Assignments', path: '/student/assignments' },
    { icon: Award, label: 'My Results', path: '/student/results' },
    { icon: FileBarChart, label: 'Report Card', path: '/student/report-card' },
    { icon: BookOpen, label: 'Lesson Notes', path: '/student/lessons' },
    { icon: Brain, label: 'AI Tutor', path: '/student/ai' },
  ],
};

const ROLE_LABELS = {
  master: 'Master Admin',
  school: 'School Admin',
  teacher: 'Teacher',
  parent: 'Parent',
  student: 'Student',
};

export default function AdminLayout({ role }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [unreadComments, setUnreadComments] = useState(0);
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const { user, school, logout, subscriptionStatus, graceDaysRemaining } = useAuth();
  const navigate = useNavigate();
  const intervalRef = useRef(null);

  // Grace period / expired subscription enforcement for school admins
  useEffect(() => {
    if (role !== 'school') return;
    if (subscriptionStatus === 'expired') {
      // Full lockout — redirect to subscription page
      if (!window.location.pathname.startsWith('/school/subscription') &&
          !window.location.pathname.startsWith('/school/billing')) {
        navigate('/school/subscription', { replace: true });
      }
    }
  }, [subscriptionStatus, role, navigate]);

  // Capture PWA install prompt
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      setShowInstallBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') setShowInstallBanner(false);
    setInstallPrompt(null);
  };

  // Fetch unread comment count for teachers
  useEffect(() => {
    if (role !== 'teacher') return;
    const fetch = () => {
      api.get('/lesson-notes/notification-count')
        .then(r => setUnreadComments(r.data?.unread || 0))
        .catch(() => {});
    };
    fetch();
    intervalRef.current = setInterval(fetch, 60000);
    return () => clearInterval(intervalRef.current);
  }, [role]);

  // Module gating: filter school nav by plan_modules
  const navItems = (NAV_CONFIG[role] || []).filter(item => {
    if (!item.module) return true;              // always-visible items
    if (role !== 'school') return true;          // only gate school admin
    const planModules = school?.plan_modules;
    if (!planModules || planModules.length === 0) return true; // no restriction set → show all
    return planModules.includes(item.module);
  });

  const initials = user
    ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase()
    : 'U';
  const fullName = user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() : 'User';

  return (
    <div className="flex h-screen bg-[#F8FAFC] overflow-hidden" data-testid={`${role}-layout`}>
      {/* PWA Install Banner */}
      {showInstallBanner && (
        <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-50 bg-[#2563eb] text-white rounded-xl shadow-xl p-4 flex items-start gap-3" data-testid="pwa-install-banner">
          <Download className="w-5 h-5 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-semibold">Install EDUVA App</p>
            <p className="text-xs text-blue-200 mt-0.5">Add to your home screen for faster access</p>
          </div>
          <div className="flex gap-2 flex-shrink-0">
            <button
              onClick={handleInstall}
              className="text-xs bg-white text-blue-700 px-3 py-1.5 rounded-lg font-semibold hover:bg-blue-50 transition"
              data-testid="pwa-install-btn"
            >
              Install
            </button>
            <button
              onClick={() => setShowInstallBanner(false)}
              className="text-xs text-blue-200 hover:text-white px-1"
              data-testid="pwa-dismiss-btn"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/30 z-30 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── Sidebar ───────────────────────────────────────────────── */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-40 lg:z-auto
        w-[220px] bg-white border-r border-slate-200 flex flex-col
        transform transition-transform duration-300 ease-in-out
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        {/* Logo */}
        <div className="h-16 flex items-center px-5 border-b border-slate-100 flex-shrink-0">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center flex-shrink-0">
              <BookOpen className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="font-manrope font-bold text-slate-900 text-sm leading-tight">EDUVA</p>
              <p className="text-[10px] text-slate-400 leading-tight">{school?.name || ROLE_LABELS[role]}</p>
            </div>
          </div>
          <button className="ml-auto lg:hidden text-slate-400" onClick={() => setSidebarOpen(false)}>
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-0.5">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <item.icon className="w-[18px] h-[18px] flex-shrink-0" />
              <span className="flex-1">{item.label}</span>
              {/* Red dot: unread student comments on teacher's lesson notes */}
              {role === 'teacher' && item.label === 'Lesson Notes' && unreadComments > 0 && (
                <span
                  className="w-2 h-2 rounded-full bg-red-500 flex-shrink-0"
                  title={`${unreadComments} note${unreadComments > 1 ? 's' : ''} with new student comments`}
                  data-testid="lesson-notes-notification-dot"
                />
              )}
            </NavLink>
          ))}
        </nav>

        {/* User Footer */}
        <div className="border-t border-slate-100 p-4 flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-xs flex-shrink-0">
              {initials}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-xs font-semibold text-slate-800 truncate">{fullName}</p>
              <p className="text-[10px] text-slate-400 capitalize">{ROLE_LABELS[role]}</p>
            </div>
            <button
              onClick={logout}
              className="text-slate-400 hover:text-slate-600 transition-colors p-1 rounded hover:bg-slate-100"
              title="Logout"
              data-testid="logout-btn"
            >
              <LogOut className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </aside>

      {/* ── Main Content ──────────────────────────────────────────── */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Header */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-5 flex-shrink-0 z-20">
          <div className="flex items-center gap-4">
            <button
              className="lg:hidden text-slate-500 hover:text-slate-700 p-1.5 rounded-lg hover:bg-slate-100 transition-colors"
              onClick={() => setSidebarOpen(true)}
            >
              <Menu className="w-5 h-5" />
            </button>
            <div className="hidden md:flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 w-52">
              <Search className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
              <input
                placeholder="Search..."
                className="bg-transparent text-xs text-slate-600 placeholder-slate-400 outline-none w-full"
              />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button className="relative p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
              <Bell className="w-4.5 h-4.5" />
              <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 bg-red-500 rounded-full" />
            </button>

            <div className="flex items-center gap-2.5 pl-3 border-l border-slate-200">
              <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-xs">
                {initials}
              </div>
              <div className="hidden sm:block">
                <p className="text-xs font-semibold text-slate-800 leading-tight">{fullName}</p>
                <p className="text-[10px] text-slate-400 capitalize">{ROLE_LABELS[role]}</p>
              </div>
              <button
                onClick={logout}
                className="hidden sm:flex items-center gap-1 text-xs text-slate-400 hover:text-slate-600 px-2 py-1 rounded-lg hover:bg-slate-100 transition-colors"
                data-testid="header-logout-btn"
              >
                <LogOut className="w-3 h-3" />
              </button>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto bg-[#F8FAFC]">
          {/* Grace Period Banner */}
          {role === 'school' && subscriptionStatus === 'grace' && (
            <div className="bg-amber-500 text-white px-5 py-2.5 flex items-center gap-3 text-sm" data-testid="grace-period-banner">
              <AlertTriangle className="w-4 h-4 flex-shrink-0" />
              <span className="flex-1 font-medium">
                Your subscription has expired. You have <strong>{graceDaysRemaining ?? '?'} day(s)</strong> remaining in your grace period before access is suspended.
              </span>
              <button
                onClick={() => navigate('/school/subscription')}
                className="px-3 py-1 bg-white text-amber-600 text-xs font-bold rounded-lg hover:bg-amber-50 transition-colors flex-shrink-0"
                data-testid="grace-renew-btn"
              >
                Renew Now
              </button>
            </div>
          )}
          <Outlet />
        </main>
      </div>
    </div>
  );
}
